<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit brand') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteBrandModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/brands">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateBrand">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Brand information') }}
              </h3>
              <p class="form-description-text">{{ $t('Brand information and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="brand.name" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="importing"></loading>
        <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
          <div class="md:col-span-1">
            <h3 class="form-description-head">
              {{ $t('Import devices for brand with CSV file') }}
            </h3>
            <p class="form-description-text">
              {{ $t('Upload file for batch entries') }}.
              <br />
              {{ $t('A file should be CSV with format') }}.
              <br />
              {{ $t('A file must have only columns with title of') }}
              <span class="text-red-600">"name","model"</span>
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="name">{{ $t('Excel CSV file') }}</label>
                <div class="pt-1">
                  <input @change="onChangeFileUpload" class="form-input" ref="file" required type="file" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="inline-flex">
            <button :disabled="!file" @click="importBrandDevices" class="btn btn-app shadow-sm rounded-md" type="submit">
              {{ $t('Upload') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <brand-delete-model :show="deleteBrandModal" @cancelled="deleteBrandModal = false" @confirmed="deleteBrand">
      <template #title>{{ $t('Brand delete') }}</template>
      {{ $t('Are you sure you want to delete the brand?') }}
      {{ $t('All data will be permanently removed') }}. {{ $t('All related data will be deleted') }}.
    </brand-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  components: {
    BrandDeleteModel: confirmationModel,
  },
  metaInfo() {
    return {
      title: this.$i18n.t('Edit brand'),
    };
  },
  data() {
    return {
      loading: true,
      importing: false,
      deleteBrandModal: false,
      brand: {
        name: null,
      },
      file: null,
    };
  },
  mounted() {
    this.getBrand();
  },
  methods: {
    importBrandDevices() {
      this.importing = true;
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('brand_id', this.$route.params.id);
      axios
        .post(route('devices.import'), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          this.importing = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/brands');
        })
        .catch(() => {
          this.importing = false;
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    updateBrand() {
      this.loading = true;
      axios
        .put(route('brands.update', this.$route.params.id), this.brand)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBrand() {
      this.loading = true;
      axios
        .get(route('brands.show', this.$route.params.id))
        .then((response) => {
          this.brand = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteBrand() {
      axios
        .delete(route('brands.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/brands');
        })
        .catch(() => {
          this.deleteBrandModal = false;
        });
    },
  },
};
</script>
